import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import PortalIdParser from 'PortalIdParser';
const BASE_URL_V2 = 'users/v2/app';
const getHubUsersKey = () => 'HubUsers';
const _fetchHubUsers = () => https.get(`${BASE_URL_V2}/hub-users`, {
  query: {
    hubId: PortalIdParser.get(),
    active: true,
    activePermissions: true,
    visible: true
  }
});
const getHubUsersLeadFlows = () => getFromEarlyRequest(getHubUsersKey(), () => _fetchHubUsers());
export default getHubUsersLeadFlows;